/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prefer-stateless-function */
import React from "react";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";

// Styled Slider to match Figma design
const StyledSlider = withStyles({
  root: {
    color: "#586B94",
    height: 4,
    padding: "22px 0",
    position: "relative",
    zIndex: 1,
  },
  thumb: {
    height: 28,
    width: 28,
    backgroundColor: "#fff",
    border: "0.5px solid rgba(0, 0, 0, 0.04)",
    marginTop: -12,
    marginLeft: -14,
    boxShadow:
      "0px 3px 1px 0px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 0.16), 0px 3px 8px 0px rgba(0, 0, 0, 0.15)",
    zIndex: 2,
    "&:focus, &:hover, &$active": {
      boxShadow:
        "0px 3px 1px 0px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 0.16), 0px 3px 8px 0px rgba(0, 0, 0, 0.15)",
    },
  },
  active: {},
  track: {
    height: 4,
    borderRadius: 2,
    backgroundColor: "#586B94",
    zIndex: 1,
  },
  rail: {
    height: 4,
    borderRadius: 2,
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    zIndex: 1,
  },
})(Slider);

class RangeSlider extends React.Component {
  render() {
    const {
      stepSize,
      defaultRangeValue,
      onChange,
      value,
      valueLabelDisplay = "auto",
      valueLabelFormat,
      marks,
      preferredTimeMinutes,
    } = this.props;

    // Visual range is always 8am to 11pm for consistent display and positioning
    // The parent component handles clamping values to respect actual availability
    const visualMin = 480; // 8:00 AM
    const visualMax = 1380; // 11:00 PM
    
    // Calculate preferred time position as a percentage using the visual range
    const preferredTimePercent = preferredTimeMinutes
      ? ((preferredTimeMinutes - visualMin) /
          (visualMax - visualMin)) *
        100
      : null;

    // Format preferred time for display
    const preferredTimeFormatted = preferredTimeMinutes
      ? valueLabelFormat
        ? valueLabelFormat(preferredTimeMinutes)
        : `${Math.floor(preferredTimeMinutes / 60)}:${String(
            preferredTimeMinutes % 60
          ).padStart(2, "0")}`
      : null;

    return (
      <div style={{ position: "relative", height: "110px" }}>
        {/* Preferred time indicator line - behind slider */}
        {preferredTimePercent !== null && (
          <>
            <div
              style={{
                position: "absolute",
                left: `calc(${preferredTimePercent}% - 2px)`,
                top: "0px",
                width: "4px",
                height: "48px",
                backgroundColor: "#2E364D",
                pointerEvents: "none",
                zIndex: 0,
              }}
            />
            {/* Preferred time badge at the bottom */}
            <div
              style={{
                position: "absolute",
                left: `${preferredTimePercent}%`,
                top: "49px",
                transform: "translateX(-50%)",
                backgroundColor: "#2E364D",
                borderRadius: "4px",
                padding: "6px 8px",
                pointerEvents: "none",
                zIndex: 0,
                whiteSpace: "nowrap",
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                {preferredTimeFormatted}
              </span>
            </div>

            {/* Preferred time label below the badge */}
            <div
              style={{
                position: "absolute",
                left: `${preferredTimePercent}%`,
                top: "89px",
                transform: "translateX(-50%)",
                pointerEvents: "none",
                zIndex: 0,
                whiteSpace: "nowrap",
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#757575",
                  textAlign: "center",
                  marginTop: "8px",
                }}
              >
                Preferred time
              </span>
            </div>
          </>
        )}
        <StyledSlider
          defaultValue={defaultRangeValue}
          value={value}
          onChange={onChange}
          valueLabelDisplay={valueLabelDisplay}
          valueLabelFormat={valueLabelFormat}
          marks={marks}
          min={visualMin}
          step={stepSize}
          max={visualMax}
        />
      </div>
    );
  }
}

export default RangeSlider;
